import Account from "callable-data-objects/dist/models/account/Account";
import FlowView from "Components/Device/Flow/FlowView";
import EventsView from "Components/Events/EventsView";
import useCheckRole from "Hooks/APICheckRole";
import APIAccountDeviceProvider from "Providers/APIDeviceProvider";
import APIEventsProvider from "Providers/APIEventsProvider";
import React, { useState } from "react";
import { Breadcrumb, Dimmer, Loader, Menu } from "semantic-ui-react";
import AccountSettings from "./AccountSettings";

type AccountDetailsProps = {
  account: Account;
  unselect: Function;
  submitting: boolean;
};

const AccountDetails = ({
  account,
  unselect,
  submitting,
}: AccountDetailsProps) => {
  const { hasRole, roles } = useCheckRole();

  const hasFlow = hasRole(roles.account.flow.roles.view);
  const hasSettings = hasRole(roles.account.settings.roles.view);
  const hasEvents = hasRole(roles.account.events.roles.view);

  const getView = () => {
    if (hasFlow) return "flow";
    if (hasSettings) return "settings";
    if (hasEvents) return "events";
    return "noRoles";
  };

  const [activeMenu, setActiveMenu] = useState<string>(getView());
  return (
    <Dimmer.Dimmable dimmed={submitting}>
      {menu(
        account,
        unselect,
        activeMenu,
        setActiveMenu,
        hasFlow,
        hasSettings,
        hasEvents
      )}
      {renderView(activeMenu, setActiveMenu)}
      <Dimmer inverted active={submitting}>
        <Loader />
      </Dimmer>
    </Dimmer.Dimmable>
  );
};

const renderView = (
  activeMenu: string,
  setActiveMenu: React.Dispatch<React.SetStateAction<string>>
) => {
  if (activeMenu === "flow") {
    return (
      <APIAccountDeviceProvider>
        <FlowView />
      </APIAccountDeviceProvider>
    );
  }
  if (activeMenu === "events") {
    return (
      <APIEventsProvider>
        <EventsView />
      </APIEventsProvider>
    );
  }
  if (activeMenu === "settings") {
    return <AccountSettings />;
  }
};

const menu = (
  account: Account,
  unselect: Function,
  activeMenu: string,
  setActiveMenu: React.Dispatch<React.SetStateAction<string>>,
  hasFlow: Boolean,
  hasSettings: Boolean,
  hasEvents: Boolean
) => {
  return (
    <Menu stackable pointing>
      <Menu.Item header>{breadcrumb(account, unselect)}</Menu.Item>
      <Menu.Menu position='right'>
        {hasFlow && (
          <Menu.Item
            icon='fork'
            name='flow'
            active={activeMenu === "flow"}
            onClick={() => setActiveMenu("flow")}
          />
        )}
        {hasEvents && (
          <Menu.Item
            icon='tasks'
            name='events'
            active={activeMenu === "events"}
            onClick={() => setActiveMenu("events")}
          />
        )}
        {hasSettings && (
          <Menu.Item
            icon='cog'
            name='settings'
            active={activeMenu === "settings"}
            onClick={() => setActiveMenu("settings")}
          />
        )}
      </Menu.Menu>
    </Menu>
  );
};

const breadcrumb = (account: Account, unselect: Function) => {
  return (
    <Breadcrumb>
      <Breadcrumb.Section link onClick={() => unselect()}>
        Accounts
      </Breadcrumb.Section>
      <Breadcrumb.Divider />
      <Breadcrumb.Section>{account.name}</Breadcrumb.Section>
    </Breadcrumb>
  );
};

export default AccountDetails;
